import Swiper from 'swiper';
import { gsap } from "gsap";
export default () => {
    // gsap.registerPlugin(Draggable);

    const productPage = document.querySelector('.product-detail');
    
    if (!productPage) return
    const main = document.querySelector('main');
	const fixedProductPanel = document.querySelector('.product-actions_fixed');
    
    document.addEventListener('scroll', (e) => {
        (document.documentElement.scrollTop == 0)?productPage.classList.remove('finish'):false;
        const rect = productPage.getBoundingClientRect();

        let diff = rect.bottom - window.innerHeight

        if( diff < 0){
            fixedProductPanel.style.bottom =  - diff + 'px'
        } else {
            fixedProductPanel.style.bottom = '0';
        }
    });
    if ( !document.querySelector('.product-detail-container')){return}
    const mySwiper = new Swiper('.product-detail-container', {
		direction: 'vertical',
		slidesPerView: 1,
		spaceBetween: 0,
        speed: 400,
		mousewheel: true,
		touchReleaseOnEdges: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
        on: {
            slideChangeTransitionStart(){
                mySwiper.wrapperEl.classList.add('locked')
            },
            slideChangeTransitionEnd(){
                mySwiper.wrapperEl.classList.remove('locked')
            }
        }
	});
    mySwiper.on('slideChange', function () {
        mySwiper.isEnd? productPage.classList.add('finish'):productPage.classList.remove('finish')
    });
    document.querySelector('.product-detail-container').addEventListener('mousewheel', (e)=>{
        if (e.deltaY > 0) {
            fixedProductPanel.style.bottom = '0';
        }
        if (productPage.classList.contains('finish')) return
        e.preventDefault();
        
        
        if (e.deltaY > 15 && e.deltaY < 200) {
            if (mySwiper.activeIndex <= mySwiper.slides.length){
                if( !mySwiper.wrapperEl.classList.contains('locked')) {
                    mySwiper.slideNext(); 
                }
            } 
        }
        if (e.deltaY < -15 && e.deltaY > -200) {
            if (mySwiper.activeIndex != 0){
                if( !mySwiper.wrapperEl.classList.contains('locked')) {
                    mySwiper.slidePrev(); 
                }
            } 
        }       
    })

    //#region old  gsap scroll
    // const slides = document.querySelectorAll('.product-detail__photo');
    // let dots = document.querySelector(".swiper-pagination");
    // const container = document.querySelector(".product-detail-container__inner");
    // let oldSlide = 0;
    // let activeSlide = 0;
    // let navDots = [];
    // let dur = 0.6;
    // let offsets = [];    

    // for (let i = 0; i < slides.length; i++) {
    //     let newDot = document.createElement("span");
    //     newDot.className = "swiper-pagination-bullet";
    //     newDot.index = i;
    //     navDots.push(newDot);
    //     newDot.addEventListener("click", slideAnim);
    //     dots.appendChild(newDot);
    //     offsets.push(-slides[i].offsetTop);
    // }

    // let newTL = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.pin-product',
    //         pin: true,
    //         start: "top top+=88px",
    //         end: "bottom top-=88px",
    //     }
    // });
    // const dotAnim = gsap.timeline({ paused: true });
    // dotAnim.to(
    //     ".swiper-pagination-bullet",
    //     {
    //       stagger: { each: 1, yoyo: true, repeat: 1 },
    //       backgroundColor: 'coral',
         
    //     },
    //     0.5
    // );
    // dotAnim.time(1);
    // // TweenMax.to(Draggable, 2, { throwProps: { x: 500, y: -300 } });
    // function slideAnim(e) {
    //     oldSlide = activeSlide;
    //     // dragging the panels
    //     if (this.id === "dragger") {
    //         activeSlide = offsets.indexOf(this.endY);
    //     } else {
    //         if (gsap.isTweening(container)) {
    //             return;
    //         }
    //         // up/down arrow clicks
    //         if (this.className === "swiper-pagination-bullet") {
    //             activeSlide = this.index;
    //             // scrollwheel
    //         } else {
    //             activeSlide = e.deltaY > 0 ? (activeSlide += 1) : (activeSlide -= 1);
    //         }
    //     }
    //     // make sure we're not past the end or beginning slide
    //     activeSlide = activeSlide < 0 ? 0 : activeSlide;
    //     activeSlide =  activeSlide > slides.length - 1 ? slides.length - 1 : activeSlide;
    //     if (oldSlide === activeSlide) {
    //         return;
    //     }
    //     // if we're dragging we don't animate the container
    //     if (this.id != "dragger") {
    //       gsap.to(container, dur, {
    //         y: offsets[activeSlide],
    //         ease: "power2.inOut",
    //         onUpdate: tweenDot,
    //       });
    //     }
    // }

    // window.addEventListener("wheel", slideAnim);

    // function tweenDot() {
    //     gsap.set(dotAnim, {
    //       time: Math.abs(gsap.getProperty(container, "y") / slides[0].offsetHeight) + 1,
    //     });
    // }
    // let dragMe = Draggable.create(container, {
    //     type: "y",
    //     edgeResistance: 1,
    //     onDragEnd: slideAnim,
    //     onDrag: tweenDot,
    //     onThrowUpdate: tweenDot,
    //     snap: offsets,
    //     inertia: true,
    //     zIndexBoost: false,
    //     allowNativeTouchScrolling: false,
    //     bounds: ".product-detail-container",
    // });
    // dragMe[0].id = "dragger";
    // dragMe[0].vars.snap = offsets;



    
    // let lastY = 0;
    // document.querySelector('.product-detail').addEventListener('touchmove', (e)=>{
    //     if (productPage.classList.contains('finish')) return
    //     let currentY = e.touches[0].clientY;
    //     e.preventDefault();
    //     console.log(e, lastY, currentY)
    //     if (currentY > lastY) {
    //         if (mySwiper.activeIndex <= mySwiper.slides.length){
    //             mySwiper.slideNext(); 
    //         } 
    //     }
    //     if (currentY < lastY) {
    //         if (mySwiper.activeIndex != 0){
    //             mySwiper.slidePrev(); 
    //         } 
    //     }       
    // })

    //#endregion

};


